'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalendarTypeToggle = undefined;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _datepickerLocal = require('./datepicker.local.css');

var _datepickerLocal2 = _interopRequireDefault(_datepickerLocal);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var CalendarTypeToggle = exports.CalendarTypeToggle = function CalendarTypeToggle(_ref) {
  var setSelectedPickerType = _ref.setSelectedPickerType,
      currentCalendar = _ref.currentCalendar,
      close = _ref.close;
  return _react2.default.createElement('div', {
    className: _datepickerLocal2.default.calendarTypeToggle
  }, _react2.default.createElement('button', {
    id: 'months',
    'data-auto': 'months',
    onClick: function onClick() {
      return setSelectedPickerType('month');
    },
    className: (0, _classnames2.default)(_datepickerLocal2.default.calendarTypeToggleButton, currentCalendar === 'month' && _datepickerLocal2.default.calendarTypeToggleButtonSelected)
  }, 'Months'), _react2.default.createElement('button', {
    id: 'days',
    'data-auto': 'days',
    onClick: function onClick() {
      return setSelectedPickerType('day');
    },
    className: (0, _classnames2.default)(_datepickerLocal2.default.calendarTypeToggleButton, currentCalendar === 'day' && _datepickerLocal2.default.calendarTypeToggleButtonSelected)
  }, 'Days'), _react2.default.createElement('button', {
    id: 'close',
    onClick: function onClick() {
      return close();
    },
    className: _datepickerLocal2.default.calendarClose,
    'aria-label': 'Close'
  }, _react2.default.createElement(_icon2.default, {
    icon: 'close',
    size: 'small'
  })));
};

CalendarTypeToggle.propTypes = {
  setSelectedPickerType: _propTypes2.default.func.isRequired,
  currentCalendar: _propTypes2.default.string.isRequired,
  close: _propTypes2.default.func.isRequired
};
exports.default = CalendarTypeToggle;